var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v("上海国开投资管理有限公司")])
}
var staticRenderFns = []

export { render, staticRenderFns }